import {IAttributes, IAugmentedJQuery, IDirective, IModule, IScope, ITimeoutService} from "angular";
import {regNavn} from "../tjenester/tredjepartsTjenestenavn";

export function registrerToggleKlasseVedStickyDirektiv(modul: IModule) {
    modul.directive("toggleKlasseVedSticky", toggleKlasseVedStickyForInjisering())
}

function toggleKlasseVedStickyForInjisering() {
    return [regNavn.ng.$timeout, toggleKlasseVedSticky]
}

function toggleKlasseVedSticky($timeout: ITimeoutService): IDirective {
    return {
        restrict: 'A',
        link: ($scope: IScope, $element: IAugmentedJQuery, $attr: IAttributes) => {
            const klasseVedSticky = $attr.toggleKlasseVedSticky;
            const observatør = new IntersectionObserver(
                ([e]) => e.target.classList.toggle(klasseVedSticky, e.intersectionRatio < 1),
                {threshold: [1]}
            );
            $timeout(() => observatør.observe($element[0]), 0, false); //ingen grunn til å kjøre digest ifbm dette
        }
    }
}
